import { useEffect } from "react";

export function useTitle(title) {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = "Operating Reality — See how work actually works.";
    };
  }, [title]);
}
